export function isCommissionTypeOverview(commissionType) {
    return commissionType === "ONE_TIME_OVERVIEW" || commissionType === "CYCLICAL_OVERVIEW";
}
